// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle_32VQX","titleImg":"SectionTitle_titleImg_1UYDN"};